import { Editor, Range } from "slate";
import { withRemoveEmptyNodes } from "@udecode/plate-normalizers";

import { insertLink, applyLinkToTextBefore } from "./transforms";
import { LinkType } from "./types";
import { isLinkElement } from "components/slate/plugins/link/utils";

const triggerRegex = /\s/;
const splitTextByUrlRegex = /((?:(?:https?:\/\/)|(?:www\.))[^\s]+)/;

export const withLink = (editor: Editor) => {
  const { insertText, insertBreak, isInline } = editor;

  editor.isInline = (element) => isLinkElement(element) || isInline(element);

  editor.insertText = (text) => {
    if (text.length > 1) {
      const parts = text.split(splitTextByUrlRegex);

      let idx = 0;
      while (idx < parts.length) {
        const text = parts[idx++];
        const url = parts[idx++];

        insertText(text);

        if (url) {
          insertLink(editor, url);
        }
      }

      return;
    }

    if (
      triggerRegex.test(text) &&
      editor.selection &&
      Range.isCollapsed(editor.selection)
    ) {
      applyLinkToTextBefore(editor);
    }

    insertText(text);
  };

  editor.insertBreak = () => {
    applyLinkToTextBefore(editor);

    insertBreak();
  };

  // empty link still exists in editor (e.g. after backwards removing)
  editor = withRemoveEmptyNodes(
    editor as any,
    {
      options: { types: [LinkType] },
    } as any
  );

  return editor;
};
